import { render, staticRenderFns } from "./PremiumInput.vue?vue&type=template&id=331b1753&scoped=true"
import script from "./PremiumInput.vue?vue&type=script&lang=js"
export * from "./PremiumInput.vue?vue&type=script&lang=js"
import style0 from "./PremiumInput.vue?vue&type=style&index=0&id=331b1753&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331b1753",
  null
  
)

export default component.exports